<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2022-04-28 15:58:26
 * @LastEditors: shijianchen shijianchen@tujia.com
 * @LastEditTime: 2022-05-31 11:25:34
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/lincoln202206/components/radio.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="radio-list">
        <div @click="selectRadio(item.value)" v-for="(item,index) in radioList" :key="index" class="radio" >
            <span class="radio-box" :class="{'checked':item.checked}"></span>{{item.label}}
        </div>
    </div>
</template>

<script>
export default {
    props:['list','value'],
    data(){
        return {
            radioList:[],
            val:''
        }
    },
    created(){
        this.radioList = [...this.list];
        this.val = this.value;
        this.selectRadio(this.val);
    },
    methods:{
        selectRadio(value){
            this.radioList.forEach((item,index)=>{
                if(item.value==value){
                    item.checked = true;
                    this.$emit('input',item.value);
                }else{
                    item.checked = false;
                }
            })
        }
    }
}
</script>

<style lang="less" scoped="true">
    .radio-list{
        display: flex;
        align-items: center;
        .radio{
            flex:1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top:4px;
            padding-bottom:4px;
            font-size: 12px;
            color:#666;
            &-box{
                display: inline-block;
                width:15px;
                height:15px;
                border:1px solid #484a41;
                border-radius: 50%;
                margin-right:5px;
                box-sizing: border-box;
                &.checked{
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &:before{
                        content: "";
                        display: block;
                        height:7px;
                        width:7px;
                        border-radius: 50%;
                        background-color:#484a41;
                    }
                }
            }
        }
    }
</style>